import Component from 'gia/Component'
import render from '../components/render'
import stage from '../components/stage'
import _each from 'lodash.foreach'

class Fyi extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)


    this.ref = {
      sketch: null,
      box: []
    }

  }


  mount() {
    //console.log("Mount Sticky!");



    this.resizeQue = this.resize.bind(this)
    stage.on("stage:resize", this.resizeQue);
    this.renderQue = this.render.bind(this)
    stage.on("stage:scroll", this.renderQue);
    this.resize(stage);
  }

  unmount() {
    //console.log("Unmount Sticky!");

    stage.removeAllListeners();

  }


  resize(e){

    // this.h = e.h/2
    // this.element.dataset.top = this.el.offset().top + this.options.y
    // this.element.dataset.height = this.el.height()

    _each(this.ref.box, (o)=>{
        o.dataset.top = $(o).offset().top
    })

    this.render(stage)

  }


  render(e){

        _each(this.ref.box, (o)=>{
            const pad = o.dataset.pad != undefined ? e.h/4 : 0
          //  console.log(o.dataset.pad);
            $(o).toggleClass('in-view', e.scrolltop + e.h - o.dataset.top - pad >= 0)
        })

  }


}

module.exports = Fyi
